import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
} from "@chakra-ui/react";
import { Spacing } from "goi_common";
import { baseColors } from "goi_common/src/design-system";
import { BaseStack } from "goi_common/src/design-system";
import { FAQ_ITEMS } from "../constants/contentData";

export default function ContentFaqSection() {
  return (
    <BaseStack
      width="100%"
      backgroundColor={baseColors.fill_normal}
      padding="40px 0"
    >
      <Box
        className="headline_1_sb"
        color={baseColors.label_normal}
        padding="0 20px"
      >
        자주 묻는 질문
      </Box>
      <Spacing gap={24} />
      <Box padding="0 20px">
        <Accordion allowToggle width="100%">
          {FAQ_ITEMS.map(({ id, question, answer }) => (
            <AccordionItem
              key={id}
              border="none"
              borderBottom={`1px solid ${baseColors.line_accent}`}
              _last={{ borderBottom: "none" }}
            >
              <AccordionButton px={0} py={4} _hover={{ bg: "transparent" }}>
                <Box
                  flex={1}
                  textAlign="left"
                  className="body_1_normal_sb"
                  color={baseColors.label_normal}
                >
                  {question}
                </Box>
                <AccordionIcon
                  color={baseColors.label_assistive_1}
                  boxSize={6}
                />
              </AccordionButton>
              <AccordionPanel px={0} pb={4}>
                <Box
                  className="body_2_reading_r"
                  color={baseColors.label_alternative_1}
                  whiteSpace="pre-line"
                >
                  {answer}
                </Box>
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Box>
    </BaseStack>
  );
}
